import ChainLogo from '@components/ChainLogo'
import { TouchableWithConfirmation } from '@components/Touchable'
import { AccountAvatar } from '@modules/AccountList'
import { Contact } from '@plug-core/interfaces/common'
import { useContacts } from '@plug-core/state'
import { ListRow, cn } from '@ui'
import React from 'react'
import { MdDelete } from 'react-icons/md'

interface IProps {
  contact: Contact
  onClick: (contact: Contact) => void
  hideDeleteButton: boolean
}

export const ContactListItem = ({ contact, onClick, hideDeleteButton }: IProps) => {
  const { removeContact } = useContacts()

  return (
    <ListRow
      onClick={() => onClick(contact)}
      leading={<AccountAvatar avatar={contact.avatar || '👽'} size={40} background="mid" />}
      primary={
        <span className="flex min-w-0 items-center">
          <span className="truncate">{contact.name}</span>
          {contact.addresses.map((address, i) => (
            <span
              key={address.chain}
              className={cn(
                'flex shrink-0 rounded-full bg-surface p-[3px]',
                i === 0 ? 'ml-1' : '-ml-2'
              )}
            >
              <ChainLogo chain={address.chain} size={20} />
            </span>
          ))}
        </span>
      }
      trailing={
        !hideDeleteButton && (
          // The confirmation dialog portals out of the DOM but its React events still bubble
          // through this row; stop them here so confirming or dismissing never opens the contact.
          <span onClick={(e) => e.stopPropagation()}>
            <TouchableWithConfirmation scaleFactor={0.1} onClick={() => removeContact(contact.id)}>
              <span className="grid size-9 place-items-center rounded-full bg-surface-2 text-fg-2 transition-colors hover:text-danger">
                <MdDelete aria-hidden size={16} />
              </span>
            </TouchableWithConfirmation>
          </span>
        )
      }
    />
  )
}
